import React from 'react'

const ListadoProductosCombos = ({ item, baseUrl }) => {
    const imagenDefault = 'https://app.bluemoonbeautysd.com/apibluemoon/productos/images/imagendefault.jpeg'
    const imagenProducto = item.producto?.imagePrev?.[0]?.nombre_imagen
        ? `${baseUrl}productos/${item.producto.imagePrev[0].nombre_imagen}`
        : imagenDefault
    const inventarioDisponible = Number.isFinite(parseInt(item.producto?.inventarioCantidad))
        ? parseInt(item.producto.inventarioCantidad)
        : null

    return (
        <div className="row cont_Atributos col-md-12 mb-2">
            <div className='col-4'>
                <div className="combo-producto-imagen">
                    <img
                        className="combo-producto-imagen__img"
                        src={imagenProducto}
                        alt={item.producto.nombre_producto}
                        loading="lazy"
                        decoding="async"
                        onError={(e) => {
                            e.currentTarget.onerror = null
                            e.currentTarget.src = imagenDefault
                        }}
                    />
                </div>
            </div>
            <div className='col'>
                <p className='p-0 m-0'>{item.producto.nombre_producto}</p>
                <AtributosProducto item={item} />
                {inventarioDisponible !== null ? <p className='p-0 m-0'>Cantidad Disponible: {inventarioDisponible}</p> : null}
            </div>
        </div>
    )
}

const AtributosProducto = ({ item }) => {
    if (!item.atributos && !item.opciones && item.producto) return (
        <>
            <span>(x{item.cantidad}) {item.producto.nombre_producto} </span>
        </>
    )

    if (item.opciones.padre == 'Colores') return (
        <>
            <span>(x{item.cantidad}) {item.opciones.padre}: </span>
            <button type="button" key={item.opciones.color} className={`btn-colores-opciones   btn`} style={{ background: item.opciones.color }} />
        </>
    )

    return (
        <>
            <span>(x{item.cantidad}) {item.opciones.padre}: </span>
            <button type="button" key={item.opciones.nombre} className={` btn btn-sm producto-atributos-btn`}>{item.opciones.nombre}</button>
        </>
    )
}


export default ListadoProductosCombos
